import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import DiscountDetailsHeaderWeb from "./layouts/DiscountDetailsHeader.web";
import DiscountDetailsHeaderMob from "./layouts/DiscountDetailsHeader.mob";

const DiscountDetailsHeaderComponent = withConditionalComponent(DiscountDetailsHeaderWeb, DiscountDetailsHeaderMob);

type Props = {
  brandName?: string;
  isFetching?: boolean;
};

const DiscountDetailsHeader: FC<Props> = ({ brandName, isFetching }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <DiscountDetailsHeaderComponent trigger={isLargeScreen} props={{ brandName, isFetching }} />;
};

export default DiscountDetailsHeader;
